import {
  HomeScreen,
  ProfileScreen,
  SetupWizardFiveScreen,
  SetupWizardFourScreen,
  SetupWizardScreen,
  SetupWizardSevenScreen,
  SetupWizardSixScreen,
  SetupWizardThreeScreen,
  SetupWizardTwoScreen,
  SetupWizardEightScreen,
  WelcomeScreen,
  SettingAccountScreen,
  SettingUserManagementScreen,
  SettingAccountManagementScreen,
  CompanySettingsScreen,
  ClusterSettingsScreen,
  AddClusterScreen,
  ChartOfAccountsScreen,
  AccountsScreen,
  FinanceForecastScreen,
  FinanceReconcileScreen,
  SetupWizardNineScreen,
  FinanceReconcileUploadSettingsScreen,
  EmployeeListScreen,
  SetupWizardTenScreen,
  AddEmployeeScreen,
  EditEmployeeScreen,
  LaborPolicyScreen,
  EmployeePendingApprovalScreen,
  InventoryGeneralSettingsScreen,
  InventoryCountSettingsScreen,
  OnlifeSitesSetupScreen,
  PosSettingsScreen,
  RoomLayoutScreen,
  IntegrationsScreen,
  IntegrationsEditScreen,
  GeneralScreen,
  LoadingScreen,
  SettingsClipboardScreen,
  PayrollsLaborSummaryScreen,
  InventorySummariesScreen,
  ReportsScreen,
  InventoriesScreen,
  ProductionsScreen,
  WastesScreen,
  CountsScreen,
  OnlifeScreen,
  TestPageScreen,
  FinanceSalesScreen,
  FinanceExpensesScreen,
  FinancePaymentsScreen,
  FinancePayablesScreen,
  FinanceReceivablesScreen,
  FinanceAssetsScreen,
  FinanceGeneralLedgerScreen,
  FinanceVouchersScreen,
  FinanceVoucherListScreen,
  FinanceReconciliationScreen,
  OrderTradeScreen,
  OrderFormScreen,
  OrdersPendingApprovalScreen,
  PendingOrdersScreen,
  ConfirmedOrdersScreen,
  CancelledOrdersScreen,
  OrderNonTradeScreen,
  OrderPayeesScreen,
  OrderApInvoicesScreen,
  OrderArInvoicesScreen,
  OrderTransfersScreen,
  OrderCustomersScreen,
  LaborShiftScreen,
  LaborSchedulerScreen,
  LaborLeaveAndClaimsScreen,
  LaborPayrollScreen,
  LaborSalarySlipsScreen,
  MenuItemsScreen,
  MenuRecipesScreen,
  MenuPromotionsScreen,
  MenuPricingScreen,
  MenuIngredientsScreen,
  OrderGeneralSettingScreen,
  FinanceGeneralSettingScreen,
  TableMasterScreen,
  HardwareMasterScreen,
  QrOrderingScreen,
  MenuSequencingScreen,
  QrListScreen,
  QrHistoryScreen,
  OrdrrOnlineScreen,
  SyncScreen,
  LoyaltyScreen,
  MarketingScreen,
  ReservationScreen,
  OrderPaymentsScreen,
  RefundsScreen,
  RefundsBillScreen,
  RefundsInnerMenuItemsScreen,
  VoidsScreen,
  DiscountsScreen,
  TipsScreen,
  PromotionsScreen,
  PromotionsSalesDetailsScreen,
  FinanceSubmittedPaymentsScreen,
  FinanceNewPaymentScreen,
  FinanceViewPaymentScreen,
  FinanceEditPaymentScreen,
  ApCreditNotesScreen,
  DetailsScreen,
  CreditNotesScreen,
  IncomingPaymentsScreen,
  NewAssetScreen,
  JournalEntriesScreen,
  NewPurchaseScreen,
  PendingPurchaseScreen,
  ConfirmedPurchaseScreen,
  CancelledPurchaseScreen,
  NewApInvoicesScreen,
  PendingApInvoicesScreen,
  VerifiedApInvoicesScreen,
  CancelledApInvoicesScreen,
  NewArInvoicesScreen,
  PaidArInvoicesScreen,
  OutstandingArInvoicesScreen,
  CancelledArInvoicesScreen,
  NewPayeeScreen,
  NewCustomerScreen,
  NewShiftScreen,
  VerifiedShiftsScreen,
  CompletedShiftsScreen,
  SubmittedPayrollsScreen,
  SubmitPayrollPendingApprovalScreen,
  PendingRequestsScreen,
  FinanceApprovedPaymentsScreen,
  RejectedRequestsScreen,
  NewItemScreen,
  CategoriesScreen,
  ModifiersScreen,
  NewRecipeScreen,
  NewIngredientScreen,
  IngredientsPendingApprovalScreen,
  ScheduledPriceUpdateScreen,
  NewPromotionScreen,
  InventoryLogScreen,
  AdHocChecksScreen,
  ExpenseScreen,
  OperationsScreen,
  PandLScreen,
  BalanceScreen,
  CashflowScreen,
  VarianceScreen,
  WasteScreen,
  ClipboardScreen,
  SettingClipboardScreen,
  CodesScreen,
  GmWelcomeScreen,
  OrderInvoicesScreen,
  OrderTransferScreen,
  AddSubAccountScreen,
  EditSubAccountScreen,
  AddTransactionScreen,
  EditIngredientScreen,
  EditRecipeScreen,
  OrdrrOnlineMenuScreen,
  OrdrrOnlineDeliveryScreen,
  ApiKeyListingScreen,
  LaborWelcomeScreen,
  FirstLaborPolicyScreen,
  LaborsSummaryScreen,
  LaborsSummaryStep2Screen,
  InventoryrWelcomeScreen,
  InventorySummaryScreen,
  InventorySummaryStep2Screen,
  AddFinanceSalesScreen,
  OrderPaymentsItemScreen,
  OrderPaymentsViewBillsScreen,
  OrderPaymentsBundleItemScreen,
  OrderPaymentsComponentScreen,
  SalesViewScreen,
  RefundsInnerComponentsScreen,
  VoidsInnerComponentScreen,
  EditItemScreen,
  FinancePendingPaymentsScreen,
  FinanceRejectedPaymentsScreen,
  ApprovedRequestsScreen,
  AddPayeePendingApprovalScreen,
  NewApCreditNoteScreen,
} from "../Scenes/Screens";

import { LoginScreen, RegisterScreen } from "../Scenes/AuthScreens";

import UnableToLoadData from "../Scenes/Components/UnableToLoadData";

export const Routing1 = [
  {
    path: "/",
    component: LoginScreen,
  },
  {
    path: "/register",
    component: RegisterScreen,
  },
  {
    path: "/activation/:email/:code",
    component: LoadingScreen,
  },
  {
    path: "not_found",
    component: UnableToLoadData,
  },
];

export const Routing = [
  {
    path: "/dashboard",
    component: HomeScreen,
  },
  {
    path: "/gm-welcome",
    component: GmWelcomeScreen,
  },
  {
    path: "/welcome",
    component: WelcomeScreen,
  },
  {
    //Setup-Wizard
    path: "/setup-wizard",
    component: SetupWizardScreen,
  },
  {
    path: "/setup-wizard-two",
    component: SetupWizardTwoScreen,
  },
  {
    path: "/setup-wizard-three",
    component: SetupWizardThreeScreen,
  },
  {
    path: "/setup-wizard-four",
    component: SetupWizardFourScreen,
  },
  {
    path: "/setup-wizard-five",
    component: SetupWizardFiveScreen,
  },
  {
    path: "/setup-wizard-six",
    component: SetupWizardSixScreen,
  },
  {
    path: "/setup-wizard-seven",
    component: SetupWizardSevenScreen,
  },
  {
    path: "/setup-wizard-eight",
    component: SetupWizardEightScreen,
  },
  {
    path: "/setup-wizard-nine",
    component: SetupWizardNineScreen,
  },
  {
    path: "/setup-wizard-ten",
    component: SetupWizardTenScreen,
  },
  {
    // Settings
    path: "/settings/profile",
    component: ProfileScreen,
  },
  {
    path: "/settings/account-settings",
    component: SettingAccountScreen,
  },
  {
    path: "/settings/account-settings/company-settings/:id",
    component: CompanySettingsScreen,
  },
  {
    path: "/codes",
    component: CodesScreen,
  },
  {
    path: "/settings/user-management",
    component: SettingUserManagementScreen,
  },
  {
    path: "/settings/account-management",
    component: SettingAccountManagementScreen,
  },
  {
    path: "/settings/cluster-settings",
    component: ClusterSettingsScreen,
  },
  {
    path: "/settings/add-cluster",
    component: AddClusterScreen,
  },
  {
    path: "/settings/finance",
    component: FinanceGeneralSettingScreen,
  },
  {
    path: "/settings/order",
    component: OrderGeneralSettingScreen,
  },
  {
    path: "/settings/order/invoices",
    component: OrderInvoicesScreen,
  },
  {
    path: "/settings/order/transfer",
    component: OrderTransferScreen,
  },
  {
    path: "/settings/finance/chart-of-accounts",
    component: ChartOfAccountsScreen,
  },
  {
    path: "/settings/finance/chart-of-accounts/accounts/:id",
    component: AccountsScreen,
  },
  {
    path: "/settings/finance/chart-of-accounts/addSubAccount/:id",
    component: AddSubAccountScreen,
  },
  {
    path: "/settings/finance/chart-of-accounts/subAccounts/:id",
    component: EditSubAccountScreen,
  },
  {
    path: "/settings/finance/chart-of-accounts/addTrans/:id",
    component: AddTransactionScreen,
  },
  {
    path: "/settings/finance/forecast",
    component: FinanceForecastScreen,
  },
  {
    path: "/settings/finance/reconcile",
    component: FinanceReconcileScreen,
  },
  {
    path: "/settings/finance/reconcile/upload-settings/:id",
    component: FinanceReconcileUploadSettingsScreen,
  },
  {
    path: "/settings/labor",
    component: EmployeeListScreen,
  },
  {
    path: "/settings/labor/add-employee",
    component: AddEmployeeScreen,
  },
  {
    path: "/settings/labor/edit-employee",
    component: EditEmployeeScreen,
  },
  {
    path: "/settings/labor/policy",
    component: LaborPolicyScreen,
  },
  {
    path: "/settings/labor/employee-pending-approval",
    component: EmployeePendingApprovalScreen,
  },
  {
    path: "/settings/inventory",
    component: InventoryGeneralSettingsScreen,
  },
  {
    path: "/settings/inventory/count-settings",
    component: InventoryCountSettingsScreen,
  },
  {
    path: "/settings/onlife-sites-setup",
    component: OnlifeSitesSetupScreen,
  },
  {
    path: "/settings/pos",
    component: PosSettingsScreen,
  },
  {
    path: "/settings/pos/room-layout",
    component: RoomLayoutScreen,
  },
  {
    path: "/settings/pos/table-master",
    component: TableMasterScreen,
  },
  {
    path: "/settings/pos/hardware-master",
    component: HardwareMasterScreen,
  },
  {
    path: "/settings/pos/qr-ordering/general",
    component: QrOrderingScreen,
  },
  {
    path: "/settings/pos/qr-ordering/menu-sequencing",
    component: MenuSequencingScreen,
  },
  {
    path: "/settings/pos/qr-ordering/qr-list",
    component: QrListScreen,
  },
  {
    path: "/settings/pos/qr-ordering/history",
    component: QrHistoryScreen,
  },
  {
    path: "/settings/pos/ordrr-online/general",
    component: OrdrrOnlineScreen,
  },
  {
    path: "/settings/pos/ordrr-online/menu-sequencing",
    component: OrdrrOnlineMenuScreen,
  },
  {
    path: "/settings/pos/ordrr-online/delivery-partner",
    component: OrdrrOnlineDeliveryScreen,
  },
  {
    path: "/settings/pos/syncs",
    component: SyncScreen,
  },
  {
    path: "/settings/integrations",
    component: IntegrationsScreen,
  },
  {
    path: "/settings/integrations/edit",
    component: IntegrationsEditScreen,
  },
  {
    path: "/settings/integrations/api_keys_listing",
    component: ApiKeyListingScreen,
  },
  {
    path: "/settings/integrations/loyalty",
    component: LoyaltyScreen,
  },
  {
    path: "/settings/integrations/reservation-table-management",
    component: ReservationScreen,
  },
  {
    path: "/settings/integrations/marketing",
    component: MarketingScreen,
  },
  {
    path: "/settings/clipboard",
    component: SettingClipboardScreen,
  },

  {
    //inventory
    path: "/inventory/inventories",
    component: InventoriesScreen,
  },
  {
    path: "/inventory/inventories/inventory-log",
    component: InventoryLogScreen,
  },
  {
    path: "/inventory/productions",
    component: ProductionsScreen,
  },
  {
    path: "/inventory/productions/ad-hoc-checks",
    component: AdHocChecksScreen,
  },
  {
    path: "/inventory/wastes",
    component: WastesScreen,
  },
  {
    path: "/inventory/counts",
    component: CountsScreen,
  },

  {
    //Onlife
    path: "/onlife",
    component: OnlifeScreen,
  },

  {
    //clipboard
    path: "/clipboard",
    component: ClipboardScreen,
  },

  {
    //reporting
    path: "/reporting/finance-summary",
    component: GeneralScreen,
  },
  {
    path: "/reporting/finance-summary/expense",
    component: ExpenseScreen,
  },
  {
    path: "/reporting/finance-summary/operations",
    component: OperationsScreen,
  },
  {
    path: "/reporting/finance-summary/pandl",
    component: PandLScreen,
  },
  {
    path: "/reporting/finance-summary/balance",
    component: BalanceScreen,
  },
  {
    path: "/reporting/finance-summary/cashflow",
    component: CashflowScreen,
  },
  {
    path: "/reporting/reports",
    component: ReportsScreen,
  },
  {
    path: "/reporting/inventory-summary",
    component: InventorySummariesScreen,
  },
  {
    path: "/reporting/inventory-summary/variance",
    component: VarianceScreen,
  },
  {
    path: "/reporting/inventory-summary/waste",
    component: WasteScreen,
  },
  {
    path: "/reporting/labor-summary",
    component: PayrollsLaborSummaryScreen,
  },

  {
    // Finance
    path: "/finance/sales",
    component: FinanceSalesScreen,
  },
  {
    path: "/finance/sales/add",
    component: AddFinanceSalesScreen,
  },
  {
    path: "/finance/sales/order-payments",
    component: OrderPaymentsScreen,
  },
  {
    path: "/finance/sales/order-payments/item",
    component: OrderPaymentsItemScreen,
  },
  {
    path: "/finance/sales/order-payments/view-bills",
    component: OrderPaymentsViewBillsScreen,
  },
  {
    path: "/finance/sales/order-payments/bundle-item",
    component: OrderPaymentsBundleItemScreen,
  },
  {
    path: "/finance/sales/order-payments/component",
    component: OrderPaymentsComponentScreen,
  },
  {
    path: "/finance/sales/refunds",
    component: RefundsScreen,
  },
  {
    path: "/finance/sales/bill",
    component: RefundsBillScreen,
  },
  {
    path: "/finance/sales/inner-menu-items",
    component: RefundsInnerMenuItemsScreen,
  },
  {
    path: "/finance/sales/inner-components",
    component: RefundsInnerComponentsScreen,
  },
  {
    path: "/finance/sales/voids",
    component: VoidsScreen,
  },
  {
    path: "/finance/sales/voids/inner-component",
    component: VoidsInnerComponentScreen,
  },

  {
    path: "/finance/sales/discounts",
    component: DiscountsScreen,
  },
  {
    path: "/finance/sales/tips",
    component: TipsScreen,
  },
  {
    path: "/finance/sales/promotions",
    component: PromotionsScreen,
  },
  {
    path: "/finance/sales/promotions/promotions-sales-detail",
    component: PromotionsSalesDetailsScreen,
  },
  {
    path: "/finance/sales/sales-view",
    component: SalesViewScreen,
  },
  {
    path: "/finance/expenses",
    component: FinanceExpensesScreen,
  },
  {
    path: "/finance/payments",
    component: FinancePaymentsScreen,
  },
  {
    path: "/finance/payments/new-payment",
    component: FinanceNewPaymentScreen,
  },
  {
    path: "/finance/payments/view-payment",
    component: FinanceViewPaymentScreen,
  },
  {
    path: "/finance/payments/edit-payment",
    component: FinanceEditPaymentScreen,
  },
  {
    path: "/finance/payments/approved",
    component: FinanceApprovedPaymentsScreen,
  },
  {
    path: "/finance/payments/rejected",
    component: FinanceRejectedPaymentsScreen,
  },
  {
    path: "/finance/payments/pending",
    component: FinancePendingPaymentsScreen,
  },
  {
    path: "/finance/payments/submitted",
    component: FinanceSubmittedPaymentsScreen,
  },
  {
    path: "/finance/payables",
    component: FinancePayablesScreen,
  },
  {
    path: "/finance/payables/ap-credit-notes",
    component: ApCreditNotesScreen,
  },
  {
    path: "/finance/payables/new-ap-credit-notes",
    component: NewApCreditNoteScreen,
  },
  {
    path: "/finance/receivables",
    component: FinanceReceivablesScreen,
  },
  {
    path: "/finance/receivables/details",
    component: DetailsScreen,
  },
  {
    path: "/finance/receivables/credit_notes",
    component: CreditNotesScreen,
  },
  {
    path: "/finance/receivables/incoming_payments",
    component: IncomingPaymentsScreen,
  },
  {
    path: "/finance/assets",
    component: FinanceAssetsScreen,
  },
  {
    path: "/finance/assets/new-asset",
    component: NewAssetScreen,
  },
  {
    path: "/finance/general-ledger",
    component: FinanceGeneralLedgerScreen,
  },
  {
    path: "/finance/general-ledger/journal-entries",
    component: JournalEntriesScreen,
  },
  {
    path: "/finance/vouchers",
    component: FinanceVouchersScreen,
  },
  {
    path: "/finance/vouchers/voucher-list",
    component: FinanceVoucherListScreen,
  },
  {
    path: "/finance/reconciliation",
    component: FinanceReconciliationScreen,
  },

  {
    // Orders & Invoices
    path: "/order/trade",
    component: OrderTradeScreen,
  },
  {
    path: "/order/trade/order-form",
    component: OrderFormScreen,
  },
  {
    path: "/order/trade/orders-pending-approval",
    component: OrdersPendingApprovalScreen,
  },
  {
    path: "/order/trade/pending-orders",
    component: PendingOrdersScreen,
  },
  {
    path: "/order/trade/confirmed-orders",
    component: ConfirmedOrdersScreen,
  },
  {
    path: "/order/trade/cancelled-orders",
    component: CancelledOrdersScreen,
  },
  {
    path: "/order/non-trade",
    component: OrderNonTradeScreen,
  },
  {
    path: "/order/non-trade/new-purchase",
    component: NewPurchaseScreen,
  },
  {
    path: "/order/non-trade/pending-purchase",
    component: PendingPurchaseScreen,
  },
  {
    path: "/order/non-trade/confirmed-purchase",
    component: ConfirmedPurchaseScreen,
  },
  {
    path: "/order/non-trade/cancelled-purchase",
    component: CancelledPurchaseScreen,
  },
  {
    path: "/order/payees",
    component: OrderPayeesScreen,
  },
  {
    path: "/order/payees/new-payee",
    component: NewPayeeScreen,
  },
  {
    path: "/order/payees/add-payee-pending-approval",
    component: AddPayeePendingApprovalScreen,
  },
  {
    path: "/order/invoices",
    component: OrderTransfersScreen,
  },
  {
    path: "/order/ap-invoices",
    component: OrderApInvoicesScreen,
  },
  {
    path: "/order/ap-invoices/new-ap-invoices",
    component: NewApInvoicesScreen,
  },
  {
    path: "/order/ap-invoices/pending-ap-invoices",
    component: PendingApInvoicesScreen,
  },
  {
    path: "/order/ap-invoices/verified-ap-invoices",
    component: VerifiedApInvoicesScreen,
  },
  {
    path: "/order/ap-invoices/cancelled-ap-invoices",
    component: CancelledApInvoicesScreen,
  },
  {
    path: "/order/ar-invoices",
    component: OrderArInvoicesScreen,
  },
  {
    path: "/order/ar-invoices/new-ar-invoices",
    component: NewArInvoicesScreen,
  },
  {
    path: "/order/ar-invoices/outstanding-ar-invoices",
    component: OutstandingArInvoicesScreen,
  },
  {
    path: "/order/ar-invoices/paid-ar-invoices",
    component: PaidArInvoicesScreen,
  },
  {
    path: "/order/ar-invoices/cancelled-ar-invoices",
    component: CancelledArInvoicesScreen,
  },
  {
    path: "/order/customers",
    component: OrderCustomersScreen,
  },
  {
    path: "/order/customers/new-customer",
    component: NewCustomerScreen,
  },
  {
    path: "/order/transfers",
    component: OrderTransfersScreen,
  },

  {
    // Labor
    path: "/labor/shift",
    component: LaborShiftScreen,
  },
  {
    path: "/labor/shift/new-shift",
    component: NewShiftScreen,
  },
  {
    path: "/labor/shift/completed-shifts",
    component: CompletedShiftsScreen,
  },
  {
    path: "/labor/shift/verified-shifts",
    component: VerifiedShiftsScreen,
  },
  {
    path: "/labor/scheduler",
    component: LaborSchedulerScreen,
  },
  {
    path: "/labor/leave-and-claims",
    component: LaborLeaveAndClaimsScreen,
  },
  {
    path: "/labor/leave-and-claims/pending-requests",
    component: PendingRequestsScreen,
  },
  {
    path: "/labor/leave-and-claims/approved-requests",
    component: ApprovedRequestsScreen,
  },
  {
    path: "/labor/leave-and-claims/rejected-requests",
    component: RejectedRequestsScreen,
  },
  {
    path: "/labor/payroll",
    component: LaborPayrollScreen,
  },
  {
    path: "/labor/payroll/submitted-payrolls",
    component: SubmittedPayrollsScreen,
  },
  {
    path: "/labor/payroll/submit-payroll-pending-approval",
    component: SubmitPayrollPendingApprovalScreen,
  },
  {
    path: "/labor/salary-slips",
    component: LaborSalarySlipsScreen,
  },

  {
    // Menu
    path: "/menu/items",
    component: MenuItemsScreen,
  },
  {
    path: "/menu/items/new-item",
    component: NewItemScreen,
  },
  {
    path: "/menu/items/edit-item/:id",
    component: EditItemScreen,
  },
  {
    path: "/menu/items/categories",
    component: CategoriesScreen,
  },
  {
    path: "/menu/items/modifiers",
    component: ModifiersScreen,
  },
  {
    path: "/menu/recipes",
    component: MenuRecipesScreen,
  },
  {
    path: "/menu/recipes/new-recipe",
    component: NewRecipeScreen,
  },
  {
    path: "/menu/recipes/edit/:id",
    component: EditRecipeScreen,
  },
  {
    path: "/menu/recipes/pending-approval",
    component: IngredientsPendingApprovalScreen,
  },
  {
    path: "/menu/promotions",
    component: MenuPromotionsScreen,
  },
  {
    path: "/menu/promotions/new-promotion",
    component: NewPromotionScreen,
  },
  {
    path: "/menu/pricing",
    component: MenuPricingScreen,
  },
  {
    path: "/menu/pricing/scheduled-price-update",
    component: ScheduledPriceUpdateScreen,
  },
  {
    path: "/menu/ingredients",
    component: MenuIngredientsScreen,
  },
  {
    path: "/menu/ingredients/new-ingredient",
    component: NewIngredientScreen,
  },
  {
    path: "/menu/ingredients/edit/:id",
    component: EditIngredientScreen,
  },
  {
    path: "/menu/ingredients/pending-approval",
    component: IngredientsPendingApprovalScreen,
  },
  {
    path: "/settings/integrations/labor-welcome",
    component: LaborWelcomeScreen,
  },
  {
    path: "/settings/integrations/first-labor-policy",
    component: FirstLaborPolicyScreen,
  },
  {
    path: "/settings/integrations/labors-summary",
    component: LaborsSummaryScreen,
  },
  {
    path: "/settings/integrations/labors-summary-step2",
    component: LaborsSummaryStep2Screen,
  },
  {
    path: "/inventory/inventory-welcome",
    component: InventoryrWelcomeScreen,
  },
  {
    path: "/inventory/inventory-summary",
    component: InventorySummaryScreen,
  },
  {
    path: "/inventory/inventory-summary-step2",
    component: InventorySummaryStep2Screen,
  },

  {
    // test page
    path: "/test-page",
    component: TestPageScreen,
  },
  {
    // not found page
    path: "not_found",
    component: UnableToLoadData,
  },
];
